import React, { useState } from 'react';
import * as yup from 'yup';
import axios from 'axios';
import { useHistory, useLocation, useParams } from 'react-router';
import { SaveResponse } from 'helpers/interfaces';


interface IContext {
    isSaving: boolean

    isLoading: boolean,
    assegneeSuggestion: AssegneeSuggestion
    saveAssegneeSuggestion: (ticket: AssegneeSuggestion) => Promise<void>
}

export let assegneeSuggestionSchema = yup.object().shape({
    id: yup.string().default(''),
    ticketTypeId: yup.string().default('').required().label('Typology'),
    product: yup.string().default('').required().label('Product'),
    productStatus: yup.string().default('').required().label('Product status'),
    assignee: yup.string().default('').required(),
});

type AssegneeSuggestion = yup.InferType<typeof assegneeSuggestionSchema>;

export let assegneeSuggestionContext = React.createContext({} as IContext);

let { Provider } = assegneeSuggestionContext;

let AssegneeSuggestionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    let history = useHistory();

    let location = useLocation();

    let isNew = location.pathname.includes("/addnew");

    let [isSaving, setSaving] = useState(false);
    let [isLoading, setLoading] = useState<boolean>(isNew === false);
    let [assegneeSuggestion] = useState(assegneeSuggestionSchema.getDefault())


    let saveAssegneeSuggestion = async (assegneeSuggestion: AssegneeSuggestion) => {
        try {
            setSaving(true);
            let res = await axios.post<SaveResponse>('/api/AssegneeSuggestion/SaveAssegneeSuggestion', assegneeSuggestion);
            history.goBack();
        } catch (err) {
            setSaving(false);
        }
    }

    return (
        <Provider
            value={{
                isSaving,
                assegneeSuggestion,
                isLoading,

                saveAssegneeSuggestion,
            }}
        >
            {children}
        </Provider>
    )
}

export default AssegneeSuggestionProvider;